module.exports = __webpack_public_path__ + "img/47_35.de354804.png";